import { publicService, userService } from '../service/httpService'
import cookie from 'vue-cookie'

const actions = {
  logout: function ({ commit }) {
    return publicService.logout().then(function (response) {
      cookie.delete('ticket')
      window.location.reload()
    })
  },
  userLogout: ({ commit }) => {
    return userService.userLogout().then(function (response) {
      cookie.delete('cird-ticket')
      commit('SET_LOGIN_STATUS', false)
      window.location.reload()
    })
  },
  login: function ({ commit }) {
    return publicService
      .login()
      .then(function (response) {
        var ticket = response.headers.ticket
        cookie.set('ticket', '"' + ticket + '"')
        commit('SET_TICKET', ticket)
      })
      .catch(function () {})
  },
  userLogin: function ({ commit }, para) {
    return userService
      .userLogin(para)
      .then(function (response) {
        var ticket = response.headers.ticket
        cookie.set('cird-ticket', '"' + ticket + '"')
        commit('SET_CIRD_TICKET', ticket)
        commit('SET_LOGIN_STATUS', true)
      })
      .catch(function () {
        commit('SET_LOGIN_STATUS', false)
      })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js